/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

export const CommercialCommissionModal = ({
  isOpen,
  monthIndex,
  selectedYear,
  mesesCompletos,
  oportunidades,
  users,
  valoresMensualesComisionComercial,
  getMoneda,
  formatCurrency,
  pais,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  const opps = Array.isArray(oportunidades) ? oportunidades : [];
  const filteredOpps = opps.filter(
    (opp) =>
      opp &&
      opp.estatus === "100%" &&
      !opp.eliminada &&
      opp.facturafecha &&
      !isNaN(new Date(opp.facturafecha).getTime()) &&
      new Date(opp.facturafecha).getMonth() === monthIndex &&
      new Date(opp.facturafecha).getFullYear() === selectedYear
  );

  const resumenEjecutivos = filteredOpps.reduce((acc, opp) => {
    const desglose = valoresMensualesComisionComercial.comisionesPorOportunidad[opp.id]?.desglose || [];
    desglose.forEach((item) => {
      const nombreEjecutivo = users[item.ejecutivo] || `Ejecutivo ${item.ejecutivo}`;
      acc[nombreEjecutivo] = (acc[nombreEjecutivo] || 0) + item.comision;
    });
    return acc;
  }, {});

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContentComisionComercial} onClick={(e) => e.stopPropagation()}>
        <h3>Detalle comisión comercial - {mesesCompletos[monthIndex]}</h3>

        {/* RESUMEN POR EJECUTIVO */}
        <div className={styles.comercialSummary}>
          <h4>Resumen por Ejecutivo</h4>
          {Object.keys(resumenEjecutivos).length === 0 ? (
            <div style={{ color: "#666", fontStyle: "italic" }}>No hay comisiones en este mes</div>
          ) : (
            Object.entries(resumenEjecutivos).map(([ejecutivo, total]) => (
              <div key={ejecutivo} className={styles.comercialSummaryItem}>
                <strong>{ejecutivo}:</strong> {formatCurrency(total)}
              </div>
            ))
          )}
          <div
            className={styles.comercialSummaryItem}
            style={{ marginTop: "12px", fontSize: "1.1rem", borderTop: "1px solid #ccc", paddingTop: "8px" }}
          >
            <strong>Total mes:</strong> {formatCurrency(valoresMensualesComisionComercial.valores[monthIndex] || 0)}
          </div>
        </div>

        {/* TABLA DETALLE */}
        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th className={styles.comercialNumeroHeader}>Número Factura</th>
              <th className={styles.comercialClienteHeader}>Cliente Facturado</th>
              <th className={styles.comercialImporteHeader}>Importe Facturado</th>
              <th className={styles.comercialAgenciaHeader}>Comisión Agencia</th>
              <th className={styles.comercialEdificioHeader}>Comisión Edificio</th>
              <th className={styles.comercialNetoHeader}>Importe Neto</th>
              <th className={styles.comercialEjecutivoHeader}>Ejecutivo Asociado</th>
              <th className={styles.comercialPorcentajeHeader}>Comisión %</th>
              <th className={styles.comercialLocalHeader}>Comisión {getMoneda()}</th>
              <th className={styles.comercialLocalHeaderTotal}>COMISIÓN TOTAL {getMoneda()}</th>
            </tr>
          </thead>
          <tbody>
            {filteredOpps.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center", padding: "30px", color: "#666", fontSize: "1rem" }}>
                  No hay oportunidades facturadas en este mes
                </td>
              </tr>
            ) : (
              filteredOpps.map((oportunidad) => {
                const comisionData = valoresMensualesComisionComercial.comisionesPorOportunidad[oportunidad.id] || {};
                const desglose = comisionData.desglose || [];
                const numRows = desglose.length || 1;
                const totalComision = desglose.reduce((sum, c) => sum + c.comision, 0);

                if (desglose.length === 0) {
                  return (
                    <tr key={oportunidad.id}>
                      <td className={styles.comercialNumeroData}>{oportunidad.facturanumero || "-"}</td>
                      <td className={styles.comercialClienteData}>{oportunidad.cliente || "Sin cliente"}</td>
                      <td className={styles.comercialImporteData}>
                        {oportunidad.moneda_dolar
                          ? `US$ ${(parseFloat(oportunidad.importe) || 0).toLocaleString(pais === "Chile" ? "es-CL" : "es-PE", { maximumFractionDigits: 0 })}`
                          : formatCurrency(comisionData.importe || 0)}
                      </td>
                      <td className={styles.comercialAgenciaData}>
                        {formatCurrency(comisionData.comisionAgencia || 0)}
                      </td>
                      <td className={styles.comercialEdificioData}>
                        {formatCurrency(comisionData.comisionEdificios || 0)}
                      </td>
                      <td className={styles.comercialNetoData}>{formatCurrency(comisionData.neto || 0)}</td>
                      <td className={styles.comercialEjecutivoData}>
                        {oportunidad.ejecutivo ? users[oportunidad.ejecutivo] || "Sin Ejecutivo" : "Sin Ejecutivo"}
                      </td>
                      <td className={styles.comercialPorcentajeData}>-</td>
                      <td className={styles.comercialLocalData}>{formatCurrency(0)}</td>
                      <td className={styles.comercialLocalDataTotal}>{formatCurrency(0)}</td>
                    </tr>
                  );
                }

                return desglose.map((item, idx) => (
                  <tr key={`${oportunidad.id}-${idx}`}>
                    {idx === 0 && (
                      <>
                        <td rowSpan={numRows} className={styles.comercialNumeroData}>
                          {oportunidad.facturanumero || "-"}
                        </td>
                        <td rowSpan={numRows} className={styles.comercialClienteData}>
                          {oportunidad.cliente || "Sin cliente"}
                        </td>
                        <td rowSpan={numRows} className={styles.comercialImporteData}>
                          {oportunidad.moneda_dolar
                            ? `US$ ${(parseFloat(oportunidad.importe) || 0).toLocaleString(pais === "Chile" ? "es-CL" : "es-PE", { maximumFractionDigits: 0 })}`
                            : formatCurrency(comisionData.importe || 0)}
                        </td>
                        <td rowSpan={numRows} className={styles.comercialAgenciaData}>
                          {formatCurrency(comisionData.comisionAgencia || 0)}
                        </td>
                        <td rowSpan={numRows} className={styles.comercialEdificioData}>
                          {formatCurrency(comisionData.comisionEdificios || 0)}
                        </td>
                        <td rowSpan={numRows} className={styles.comercialNetoData}>
                          {formatCurrency(comisionData.neto || 0)}
                        </td>
                      </>
                    )}
                    <td className={styles.comercialEjecutivoData}>
                      {users[item.ejecutivo] || `Ejecutivo ${item.ejecutivo}`}
                    </td>
                    <td className={styles.comercialPorcentajeData}>{item.percentage.toFixed(2)}%</td>
                    <td className={styles.comercialLocalData}>{formatCurrency(item.comision)}</td>
                    {idx === 0 && (
                      <td rowSpan={numRows} className={styles.comercialLocalDataTotal}>
                        {formatCurrency(totalComision)}
                      </td>
                    )}
                  </tr>
                ));
              })
            )}
          </tbody>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
